import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { Shield, Award, Eye } from 'lucide-react';

const TrustSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="trust" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            {t('businessAppsPage.trust.title')}
          </h2>
        </div>
        
        {/* Garantien */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col items-center text-center transition-all hover:shadow-md">
            <div className="rounded-full bg-blue-100 p-3 mb-4">
              <Shield className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">
              {t('businessAppsPage.trust.guarantees.dataProtection.title')}
            </h3>
            <p className="text-gray-600">
              {t('businessAppsPage.trust.guarantees.dataProtection.description')}
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col items-center text-center transition-all hover:shadow-md">
            <div className="rounded-full bg-blue-100 p-3 mb-4">
              <Award className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">
              {t('businessAppsPage.trust.guarantees.quality.title')}
            </h3>
            <p className="text-gray-600">
              {t('businessAppsPage.trust.guarantees.quality.description')}
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col items-center text-center transition-all hover:shadow-md">
            <div className="rounded-full bg-blue-100 p-3 mb-4">
              <Eye className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">
              {t('businessAppsPage.trust.guarantees.transparency.title')}
            </h3>
            <p className="text-gray-600">
              {t('businessAppsPage.trust.guarantees.transparency.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection; 